import { Directive } from '@angular/core';
import { BrnFieldControlDescribedBy } from '@spartan-ng/brain/field';
import { BrnInput } from '@spartan-ng/brain/input';
import { classes } from '@spartan-ng/helm/utils';

@Directive({
  selector: '[hlmInput]',
  hostDirectives: [
    { directive: BrnInput, inputs: ['id', 'forceInvalid'] },
    BrnFieldControlDescribedBy,
  ],
  host: { 'data-slot': 'input', class: 'ocp-spartan-scope' },
})
export class HlmInput {
  constructor() {
    classes(
      () =>
        'bg-input-background border text-button-secondary-color  border-input-border hover:border-input-hover-border focus-visible:border-input-focus-border focus-visible:ring-2 focus-visible:ring-input-focus-ring focus-visible:ring-offset-2 focus-visible:ring-offset-input-background data-[matches-spartan-invalid=true]:border-input-invalid-border data-[matches-spartan-invalid=true]:placeholder:text-input-invalid-placeholder h-9 rounded-[24px] py-[7px] pr-[12px] pl-[16px] text-base transition-[color,box-shadow,background-color] file:h-7 file:text-sm file:font-medium md:text-base file:text-foreground placeholder:text-input-placeholder disabled:bg-input-disabled-background disabled:text-input-disabled-text w-full min-w-0 outline-none file:inline-flex file:border-0 file:bg-transparent disabled:pointer-events-none disabled:cursor-not-allowed'
    );
  }
}
